import { SharingOptionsRadioButton } from './radioButton';
import React, { useState } from 'react';
import { TripResponse, usePatchTripsByTripIdMutation } from '../../../../store/backendApi';
import { Input } from '../../../../components/inputs/input';

export interface SharingOptionsPageProps {
  trip: TripResponse;
  username: string;
}

export const SharingOptionsPage = (props: SharingOptionsPageProps) => {
  const [shareMode, setShareMode] = useState<'PUBLIC' | 'LINK' | 'PRIVATE' | null>(
    props.trip.shareMode,
  );
  const [slug, setSlug] = useState(props.trip.slug);
  const publicUrl = `${process.env.REACT_APP_HOST}/trip/${props.username}/${props.trip.slug}`;
  const privateUrlBase = `${process.env.REACT_APP_HOST}/trip`;
  const [patchTrip, { error: patchTripError, isLoading: patchTripLoading }] =
    usePatchTripsByTripIdMutation();

  const hasChanges = slug !== props.trip.slug || shareMode !== props.trip.shareMode;

  const reset = () => {
    setSlug(props.trip.slug);
    setShareMode(props.trip.shareMode);
  };

  const updateSlug = async () => {
    await patchTrip({
      tripId: props.trip.id,
      partialTripBodyRequest: {
        slug: slug !== props.trip.slug ? slug : undefined,
        shareMode: shareMode !== props.trip.shareMode ? shareMode || undefined : undefined,
      },
    });
    if (patchTripError) {
      console.error(patchTripError);
      alert('Trip URL could not be updated');
    }
  };

  return (
    <>
      <p className="mt-4">Control who can see your trip</p>
      <fieldset className="mt-6">
        <div className="space-y-5">
          <SharingOptionsRadioButton
            id="public"
            title="Public"
            checked={shareMode === 'PUBLIC'}
            description="Anyone can view your trip"
            onCheck={(checked: boolean) => {
              if (checked) {
                setShareMode('PUBLIC');
              }
            }}
          />
          {shareMode === 'PUBLIC' && (
            <>
              <a target="_blank" href={`https://${publicUrl}`}>
                {publicUrl}
              </a>
              <Input
                id={'slug'}
                name={'slug'}
                type={'text'}
                placeholder="trip URL"
                label="Public URL"
                value={slug}
                setValue={setSlug}
              />
            </>
          )}
          <SharingOptionsRadioButton
            id="link"
            title="Share with Link"
            checked={shareMode === 'LINK'}
            description="Anyone with the link can view your trip"
            onCheck={(checked: boolean) => {
              if (checked) {
                setShareMode('LINK');
              }
            }}
          />
          {shareMode === 'LINK' && !!props.trip.linkSecret && (
            <>
              <a target="_blank" href={`https://${privateUrlBase}/${props.trip.linkSecret}`}>
                Secret Link
              </a>
            </>
          )}
          {shareMode === 'LINK' && !props.trip.linkSecret && (
            <>
              <p>
                <i>Link will be visible after saving</i>
              </p>
            </>
          )}
          {shareMode === 'LINK' && !props.trip.linkSecret && (
            <>
              <p>
                <i>Link will be visible after saving</i>
              </p>
            </>
          )}
          <SharingOptionsRadioButton
            id="private"
            title="Private"
            checked={shareMode === 'PRIVATE'}
            description="Only selected users can view your trip"
            onCheck={(checked: boolean) => {
              if (checked) {
                setShareMode('PRIVATE');
              }
            }}
          />
        </div>
      </fieldset>
      <hr className="mt-12" />
      <div className="mt-5 sm:mt-6">
        <div className="flex gap-3">
          <button
            type="button"
            disabled={patchTripLoading || !hasChanges}
            onClick={() => {
              updateSlug();
            }}
            className="flex-1 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm disabled:text-gray-300
                font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline
                focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600
                disabled:bg-gray-500 disabled:cursor-not-allowed disabled:hover:bg-gray-500"
          >
            {patchTripLoading ? '...' : 'Save'}
          </button>
          <button
            type="button"
            onClick={reset}
            className="flex-1 justify-center rounded-md bg-gray-300 disabled:bg-gray-500 disabled:hover:bg-gray-500
             px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-400 focus-visible:outline
                focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500"
          >
            Reset
          </button>
        </div>
      </div>
    </>
  );
};
